import { PAGINEDETAIL } from './endpoint'

/** Recupera una pagina dal CMS mantenendo la risposta Axios per i chiamanti esistenti. */
const getPagina = (api, chiave, lang, headers, apiBaseUrl = '') =>
  api.get(apiBaseUrl + PAGINEDETAIL, {
    params: { chiave, lang },
    headers,
  })

export const getPaginaCondizioniServizio = (api, lang, headers, apiBaseUrl) =>
  getPagina(api, 'condizioni-servizio', lang, headers, apiBaseUrl)

export const getPaginaInformativaPrivacy = (api, lang, headers, apiBaseUrl) =>
  getPagina(api, 'informativa-privacy', lang, headers, apiBaseUrl)

/** Recupera l'URL delle condizioni e lo adatta al dominio del sito dell'ordine. */
export const getCondizioniServizioUrl = async (api, lang, headers, siteDomain) => {
  try {
    const { data } = await getPaginaCondizioniServizio(api, lang, headers)
    const url = data?.seo?.canonical_url

    if (!url) return null

    return siteDomain ? url.replace(/^(https?:\/\/)[^/]+/, `$1${siteDomain}`) : url
  } catch (error) {
    return null
  }
}
